'use strict';

/**
 * @ngdoc function
 * @name prepApp.controller:CourseTasksController
 * @description
 * # CourseTasksController
 * Controller of the prepApp
 */
angular.module('prepApp')
    .controller('CourseTasksController', function (APIs) {
        var vm = this;
        vm.selectedCourse = undefined;

        vm.courseList = [];
        APIs.CourseService.query().$promise.then(function (data) {
            angular.forEach(data, function (course) {
                vm.courseList.push(course);
            });
        });
    });
